import $ from "jquery";
import EventEmitter from "base/EventEmitter";

class Gallery extends EventEmitter {

    constructor($gallery, settings = {}) {
        super();
        settings = $.extend({
            itemClass: "gallery__image",
            pipClass: "gallery__pip",
            navigateClass: "js-navigate",
            pipsClass: "js-pips",
            itemsClass: "js-items",
            itemActiveModifier: "active",
            pipActiveModifier: "active",
            animationDuration: 250,
            applyMinHeight: false,
        }, settings);

        this.settings = settings;

        this.$gallery = $gallery;
        this.$items = this.$gallery.find("." + this.settings.itemsClass);
        this.$pips = this.$gallery.find("." + this.settings.pipsClass);

        this.changing = false;
        this.applyMinHeight = this.applyMinHeight.bind(this);

        this.bindEvents();
    }

    bindEvents() {
        const me = this;
        this.$gallery.on("click", "." + this.settings.navigateClass, function () {
            const direction = $(this).attr("data-direction");
            if (me.emit("navigate", {direction})) {
                me.navigate(direction);
            }
            return false;
        });
        this.$pips.on("click", "." + this.settings.pipClass, function () {
            const index = me.$pips.find("." + me.settings.pipClass).index(this);
            if (me.emit("goTo", {index})) {
                me.showItem(index);
            }
            return false;
        });

        if (this.settings.applyMinHeight) {
            $(window).on("resize", this.applyMinHeight);
            this.applyMinHeight();
        }
    }

    applyMinHeight() {
        this.$items.css("min-height", "");
        let height = 0;
        this.getItems().each(function () {
            height = Math.max(height, $(this).outerHeight());
        });
        this.$items.css("min-height", height + "px");
    }

    navigate(direction) {
        let index = this.getActiveIndex() + (direction === DIRECTION_FORWARDS ? 1 : -1);

        if (index < 0) {
            index = this.getItemCount() - 1;
        } else if (index >= this.getItemCount()) {
            index = 0;
        }

        this.showItem(index, direction);
    }

    getItemCount() {
        return this.getItems().length;
    }

    showItem(index, forceDirection = null) {
        if (this.changing) return;
        this.changing = true;
        let direction;

        if (forceDirection !== null) {
            direction = forceDirection;
        } else {
            direction = index > this.getActiveIndex() ? DIRECTION_FORWARDS : DIRECTION_BACKWARDS;
        }

        let inClass = this.settings.itemClass + "--in-" + direction + " " + this.settings.itemClass + "--in";
        let outClass = this.settings.itemClass + "--out-" + direction + " " + this.settings.itemClass + "--out";

        let $current = this.getActiveElement();
        let $next = this.getItem(index);

        if ($current.index() === $next.index()) {
            this.changing = false;
            return;
        }

        this.emit("transitionStart", {
            from: this.getActiveIndex(),
            to: index,
        });
        $next.addClass(inClass);
        $current.addClass(outClass);

        let pipActiveClass = this.settings.pipClass + "--" + this.settings.pipActiveModifier;
        this.$pips.find("." + this.settings.pipClass).removeClass(pipActiveClass).eq(index).addClass(pipActiveClass);

        setTimeout(() => {
            $next.removeClass(inClass).addClass(this.settings.itemClass + "--" + this.settings.itemActiveModifier);
            $current.removeClass(outClass + " " + this.settings.itemClass + "--" + this.settings.itemActiveModifier);
            this.changing = false;
            this.emit("transitionEnd", {
                from: this.getActiveIndex(),
                to: index,
            });
        }, this.settings.animationDuration);
    }

    getItems() {
        return this.$items.find("." + this.settings.itemClass);
    }

    getItem(index) {
        return this.getItems().eq(index);
    }

    getActiveIndex() {
        let $active = this.getActiveElement();

        return $active.length === 0 ? 0 : this.getItems().index($active);
    }

    getActiveElement() {
        return this.$items.find("." + this.settings.itemClass + "--" + this.settings.itemActiveModifier);
    }

    destroy() {
        this.$gallery.off("click", "." + this.settings.navigateClass);
        this.$gallery.off("click", "." + this.settings.pipsClass);

        this.$gallery = null;
        this.$items = null;

        $(window).off("resize", this.applyMinHeight);

        this.changing = false;
    }
}

const DIRECTION_FORWARDS = "forwards";
const DIRECTION_BACKWARDS = "backwards";

Gallery.BACKWARDS = DIRECTION_BACKWARDS;
Gallery.FORWARDS = DIRECTION_FORWARDS;

export default Gallery;
